import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
var NotFoundPage = function NotFoundPage(props) {
  return /*#__PURE__*/React.createElement(Container, {
    fluid: true,
    className: "text-center d-flex align-items-center justify-content-center vh-100 bg-light"
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("h1", {
    className: "display-4 text-danger"
  }, "Oops! Page Not Found (404)"), /*#__PURE__*/React.createElement("p", {
    className: "lead mt-3"
  }, "The page you're looking for doesn't exist or may have been moved."), /*#__PURE__*/React.createElement("div", {
    className: "mt-4 text-left d-inline-block mx-auto",
    style: {
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, "What can you do?")), /*#__PURE__*/React.createElement("ul", {
    className: "list-unstyled"
  }, /*#__PURE__*/React.createElement("li", null, "\u2022 Go back to the homepage"), /*#__PURE__*/React.createElement("li", null, "\u2022 Check the URL for any mistakes"), /*#__PURE__*/React.createElement("li", null, "\u2022 Or contact us if you need help")), /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    href: "/",
    className: "mt-3"
  }, "Go to Homepage")), /*#__PURE__*/React.createElement("div", null))));
};
export default NotFoundPage;